export default __webpack_public_path__ + "static/media/people.d828819a.png";